import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { CheckCircle, Shield, Truck, CreditCard, Wrench, Phone } from 'lucide-react';

export const Trucks52Benefits = () => {
  const benefits = [
    {
      icon: CheckCircle,
      title: 'Inspection complète de 125 points',
      description: 'Chaque véhicule est minutieusement inspecté par nos mécaniciens experts'
    },
    {
      icon: Shield,
      title: 'Véhicule professionnel certifié',
      description: 'Garantie de qualité et de conformité aux normes industrielles'
    },
    {
      icon: Truck,
      title: 'Livraison possible dans toute la France',
      description: 'Service de livraison sécurisée sur l\'ensemble du territoire'
    },
    {
      icon: CreditCard,
      title: 'Reprise de votre ancien véhicule',
      description: 'Nous évaluons et reprenons votre véhicule actuel au meilleur prix'
    },
    {
      icon: Phone,
      title: 'Service client réactif 7j/7',
      description: 'Une équipe dédiée pour répondre à toutes vos questions'
    },
    {
      icon: Wrench,
      title: 'Garantie mécanique disponible',
      description: 'Options de garantie étendue pour votre tranquillité d\'esprit'
    },
  ];

  return (
    <Card className="bg-gradient-to-br from-blue-50 to-white border-blue-200">
      <CardHeader>
        <CardTitle className="text-2xl text-center">
          Les atouts Trucks 52 SARL
        </CardTitle>
        <p className="text-center text-muted-foreground">
          Votre partenaire de confiance pour l'achat de véhicules industriels
        </p>
      </CardHeader>
      <CardContent>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {benefits.map((benefit, index) => {
            const Icon = benefit.icon;
            return (
              <div key={index} className="flex gap-4">
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center">
                    <Icon className="h-6 w-6 text-primary" />
                  </div>
                </div>
                <div className="flex-1">
                  <h3 className="font-semibold mb-1">{benefit.title}</h3>
                  <p className="text-sm text-muted-foreground">{benefit.description}</p>
                </div>
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
};
